export default {
    generic: {
        free: 'Gratuit',
        noresult: 'Aucun résultat 😢'
    },
    statusBar: {
        products: 'Produits',
        prices: 'Tarifs',
        infos: 'Informations',
        insurance: 'Assurance',
        payment: 'Paiement'
    },
    cart: {
        cancel: "Annuler la commande",
        order: "Passer la commande",
        order_small: "Commander",
        empty_message: "Aucun ticket pour le moment",
        empty_product_message: "Aucun produit pour le moment",
        total: "Total",
        fees: "Frais de service",
        insurance: "Assurance",
        editionFees: "Frais d'edition",
        leftToPay: "Restant dû",
        quantity_discount: "Remise"
    },
    toast: {
        welcome: 'Bienvenue {name} 👋',
        ticket_type: {
            cant_add: 'Plus de stock disponible pour ce ticket'
        }
    },
    quotaPerOrder: {
        reached: 'Limite de {quota} billet(s) par commande atteinte.',
        minimum_exceeds: 'Minimum d\'achat ({min}) supérieur au quota restant ({remaining}).',
        seats_exceeded: 'Vous ne pouvez pas sélectionner plus de {quota} billet(s) pour cette commande.',
        draft_exceeded: 'Le panier dépasse la limite de {quota} billet(s) par commande.'
    },
    tpe: {
        collectMessage: 'En attente du paiement de ',
        cancelCollect: 'Annuler'
    },
    summary: {
        title: 'Commande enregistrée',
        new_order: 'Nouvelle commande',
        show_order: 'Voir la commande',
        print_order: 'Imprimer la commande'
    },
    pages: {
        resume: {
            title: 'Vous revoilà !',
            description: "Votre compte opérateur a débuté une session le {date}. Les données de vente ont été rechargées dans votre guichet. A l'issue des ventes, pensez à fermer votre guichet pour générer votre sortie de caisse.",
            btnLabel: "Reprendre ma session"
        }
    },
    products: {
        empty: 'Aucun produit...'
    },
    global: {
        menu: {
            ticket_office: "Guichet",
            orders: "Commandes",
            stats: "Stats",
            settings: "Réglages",
            pause: "Suspendre",
            switch: "Changer",
            close: "Terminer",
            logout: "Déconnexion",
            digibuvette: "Buvette",
            fullscreen: "Plein écran",
            fullscreenQuit: "Quitter plein écran"
        }
    },
    infosPage: {
        order_infos: "Informations commande",
        tickets_infos: "Informations tickets",
        additional_questions: "Questions complémentaires"
    },
    paymentPage: {
        otherPayments: "Autres moyens de paiement",
        validate: "Valider le paiement"
    },
    insurancePage: {
        title: "Assurance",
        subtitle: "Assurez vos billets pour {price}",
        bullet1: "Garantie de remboursement intégral",
        bullet2: "Annulation possible jusqu'à 48h avant l'événement",
        bullet3: "Sur présentation d'un justificatif",
        noticeLink: "Consulter la notice d'information",
        btnSubscribe: "Souscrire à l'assurance",
        btnSkip: "Continuer sans assurance",
        errorLoad: "Service assurance temporairement indisponible",
        errorApply: "Impossible d'appliquer l'assurance, veuillez réessayer.",
        statusBarLabel: "Assurance",
    },
    form: {
        tickets: {
            email: {
                label: "Email",
                placeholder: "Email",
                help: "Si l'email est renseigné, les billets seront automatiquement envoyés sur cette adresse après achat"
            },
            firstname: {
                label: "Prénom",
                placeholder: "Tony"
            },
            zone: {
                label: "Emplacement",
                placeholder: "Loge B12"
            },
            infos: {
                label: "Informations additionnelles",
                placeholder: ""
            },
            lastname: {
                label: "Nom",
                placeholder: "Santacruz"
            },
            company: {
                label: "Société",
                placeholder: "OandB"
            },
            tva: {
                label: "Numéro de TVA",
                placeholder: "FRXXXXXXXXXXX"
            },
            address: {
                label: "Adresse",
                placeholder: "11 rue du Languedoc\n31000 Toulouse"
            }
        }
    },
    auth: {
        loginPage: {
            title: 'Bien le bonjour. 👋',
            headMessage: 'Veuillez vous connecter pour accéder à votre espace guichet.',
            form: {
                email: {
                    placeholder: "dominique{'@'}oandb.fr",
                    label: 'Adresse e-mail'
                },
                password: {
                    placeholder: 'Restons discrets ;)',
                    label: 'Mot de passe'
                },
                submit: 'Connexion'
            }
        },
        organisationPage: {
            title: 'Choisissez une organisation',
            filterPlaceHolder: 'Filtrer les résultats',
            card: {
                eventInProgress: '{number} événement(s) en cours',
                noEventInProgress: 'Aucun événement en cours'
            }
        },
        eventsPage: {
            title: 'Reprennez ou créez une session de vente',
            filterPlaceHolder: 'Filtrer les résultats',
        },
        sessionsPage: {
            title: 'Choisissez une session'
        }
    }
};
